import { render, staticRenderFns } from "./AllocationJournalSelect.vue?vue&type=template&id=3e010d7a&"
import script from "./AllocationJournalSelect.vue?vue&type=script&lang=js&"
export * from "./AllocationJournalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports